import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { godAuthApi } from '../api';

const GodAuthContext = createContext(null);

export function GodAuthProvider({ children }) {
  const [godUser, setGodUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const res = await godAuthApi.me();
      if (res.data.success) setGodUser(res.data.data);
      else setGodUser(null);
    } catch {
      setGodUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
    const handler = () => { setGodUser(null); setLoading(false); };
    window.addEventListener('tracern:god-unauthorized', handler);
    return () => window.removeEventListener('tracern:god-unauthorized', handler);
  }, [fetchMe]);

  const login = async (username, password) => {
    const res = await godAuthApi.login(username, password);
    if (res.data.success) { setGodUser(res.data.data); return res.data.data; }
    throw new Error(res.data.message);
  };

  const logout = async () => {
    await godAuthApi.logout();
    setGodUser(null);
  };

  return (
    <GodAuthContext.Provider value={{ godUser, loading, login, logout, refreshGodUser: fetchMe }}>
      {children}
    </GodAuthContext.Provider>
  );
}

export function useGodAuth() {
  return useContext(GodAuthContext);
}
